module.exports = __webpack_public_path__ + "img/10.259a97d0.png";